"use strict";
exports.__esModule = true;
exports.OrganizationType = void 0;
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Merchant"] = "merchant";
    OrganizationType["DeliveryServicePartner"] = "dsp";
})(OrganizationType = exports.OrganizationType || (exports.OrganizationType = {}));
